<template>
  <v-row>
    <v-col cols="12" class="pt-5 pt-md-9 pb-2 pb-md-5">
      <router-link :to="{ name: 'hosting_cpanel_info', params: { id: $route.params.id }}">
        <v-icon size="20">mdi-keyboard-backspace</v-icon>
        Go back to managing {{ hosting.domain }}
      </router-link>
    </v-col>
    <v-col cols="12" class="pt-0">
      <gg-card>
        <gg-card-header>
          Plan Change Status
        </gg-card-header>
        <gg-card-text>
          <v-data-table :headers="headers" :items="items" hide-default-footer :loading="loading">
            <template v-slot:item.status="{ item }">
              <v-icon small class="mb-1" :color="statusColor(item.status)">
                mdi-circle
              </v-icon>
              {{ item.status }}
            </template>
          </v-data-table>
        </gg-card-text>
      </gg-card>

    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'StatusesView',
  data: () => {
    return {
      loading: true,
      headers: [
        {
          text: 'Source',
          value: 'source',
        },
        {
          text: 'Destination',
          value: 'destination',
        },
        {
          text: 'Type',
          value: 'type',
        },
        {
          text: 'Term',
          value: 'term',
        },
        {
          text: 'Status',
          value: 'status',
        },
        {
          text: 'Created',
          value: 'created_at',
        },
      ],
      items: []
    }
  },
  async mounted () {
    await this.getData()
  },
  computed: mapGetters(['hosting']),
  methods: {
    ...mapActions({
      viewRequest: 'updowngrade/viewRequest',
      reportError: 'reportError'
    }),
    async getData () {
      try {
        this.loading = true
        const { id } = this.$route.params

        const { request } = await this.viewRequest({ id })

        this.items.push(request)
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    },
    statusColor (status) {
      switch (status) {
        case 'Pending':
          return 'yellow'
        case 'Processing':
          return 'blue'
        case 'Review':
          return 'orange'
        case 'Escalated':
          return 'red'
        default:
          return 'grey'
      }
    },
  }
}
</script>

<style scoped>

</style>
